import * as React from "react";
import { BoundActions } from "react-sweet-state";
import { Grid } from './widget';
import { Dictionary, Container } from "../state/types";
import { ControlProps, ControlWidgetProps, FieldGetter, FieldSetter } from "./Control";
import { createEntityFieldGetter, EntityState } from "../state/entity";
import { getFieldErrorsAsString } from "../validation/validatableentity";
import { Combobox } from "./Combobox";
import { Checkbox } from "./Checkbox";
import { CheckboxSelection } from "./CheckboxSelection";
import { TextInput } from "./TextInput";
import { DateInput } from "./DateInput";
import { PersonalNumberInput } from "./PersonalNumberInput";
import { NumberInput } from "./NumberInput";
import { PhoneInput } from "./PhoneInput";
import { ZipCodeInput } from "./ZipCodeInput";


type FieldType = "text" | "comboSelect" | "checkbox" | "checkboxSelect" | "date" | "personalNumber" | "phone" | "integer" | "zipCode";

interface FieldProps extends
    ControlProps,
    ControlWidgetProps {
    type?: FieldType;
    items?: Dictionary<React.ReactNode>;
}

type Fields = Dictionary<FieldProps>;


const FormControl = (props: FieldProps) => {

    const { xs, sm, md, lg, xl, type, items, ...other } = props;

    let inputControl;

    switch (type) {
        case 'comboSelect':
            inputControl = <Combobox {...other} items={items ?? {}} />;
            break;
        case 'checkbox':
            inputControl = <Checkbox {...other} />
            break;
        case 'checkboxSelect':
            inputControl = <CheckboxSelection {...other} items={items} />
            break;
        case 'date':
            inputControl = <DateInput {...other} />
            break;
        case 'personalNumber':
            inputControl = <PersonalNumberInput {...other} />
            break;
        case 'phone':
            inputControl = <PhoneInput {...other} />
            break;
        case 'integer':
            inputControl = <NumberInput {...other} />
            break;
        case 'zipCode':
            inputControl = <ZipCodeInput {...other} />
            break;



        default:
            inputControl = <TextInput {...other} />;
            break;
    }

    return (
        <Grid item xs={xs} sm={sm} md={md} lg={lg} xl={xl}>
            {inputControl}
        </Grid>
    );
}



const buildFormControlProps = (
    name: string,
    fields: Fields,
    state: EntityState<any>,
    actions: BoundActions<EntityState<any>, Container>): FieldProps => {

    const fieldDef = fields[name];

    let getter: FieldGetter<any> = createEntityFieldGetter(state);
    let setter: FieldSetter<any> = actions.setEntityField;

    return {
        ...fieldDef,
        name: name,
        error: getFieldErrorsAsString(state, name),
        getter,
        setter
    }
}


export {
    FieldProps,
    Fields,
    FieldType,
    FormControl,
    buildFormControlProps,
}
